import { render, staticRenderFns } from "./Personal_file.vue?vue&type=template&id=3c36bde6&style=height%3A%20100%25%3B"
import script from "./Personal_file.vue?vue&type=script&lang=js"
export * from "./Personal_file.vue?vue&type=script&lang=js"
import style0 from "./Personal_file.vue?vue&type=style&index=0&id=3c36bde6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports